import type en from "../en/recording";
import type { Translation } from "../../types";

const recording: Translation<typeof en> = {
  toast: {
    translating: "Traduction en cours — les sous-titres basculeront une fois terminée.",
    translationCancelled: "Traduction annulée.",
    transcribing: "Transcription en cours. Cette page se met à jour une fois terminée.",
  },
  notFound: {
    title: "Enregistrement introuvable",
    description: "Il a peut-être été supprimé, ou appartient à un autre espace de travail.",
  },
  loadError: "Impossible de charger cet enregistrement",
  pending: {
    fallback: "Cet enregistrement est encore en préparation.",
    stop: "Arrêter l’enregistrement",
    openLink: "Ouvrir le lien",
    backToLibrary: "Retour à la bibliothèque",
  },
  preparing: {
    title: "Préparation de cet enregistrement pour la lecture en continu",
    body: "Il démarrera et se positionnera instantanément une fois l’opération terminée. La transcription est déjà prête.",
    playAnyway: "Lire l’original quand même",
  },
  renameLabel: "Renommer cet enregistrement",
  captions: {
    sizeLabel: "Taille des sous-titres",
    sizeTitle: {
      s: "Petits sous-titres",
      m: "Sous-titres moyens",
      l: "Grands sous-titres",
    },
    sizeLetter: {
      s: "p",
      m: "m",
      l: "g",
    },
    languageTitle:
      "Langue des sous-titres — les nouvelles langues sont traduites avec le modèle d’IA de l’espace de travail, après votre confirmation",
    original: "Original",
    translations: "Traductions",
    translateTo: "Traduire en…",
    optionTranslating: "{{language}} · traduction…",
    optionFailed: "{{language}} · échec, choisir pour réessayer",
    cancelTitle: "Arrêter cette traduction — la facturation s’arrête au prochain lot",
    cancel: "✕ annuler",
  },
  participants_one: "{{count}} participant",
  participants_other: "{{count}} participants",
  studio: {
    button: "Monter dans Studio",
    title: "Couper, réorganiser et redécouper les chapitres de cet enregistrement",
  },
  export: {
    button: "Télécharger / Exporter",
    title: "Télécharger l’original, ou exporter avec les sous-titres incrustés",
  },
  importedFrom: "Importé depuis {{source}}",
  importedFromLink: "Importé depuis un lien",
  importedFromTitle: "Ouvrir la vidéo d’origine de cet import",
  editedFrom: "Monté à partir de « {{title}} »",
  editedFromTitle: "Cet enregistrement a été publié à partir d’un montage Studio",
  edits: "Montages :",
  noTranscript: {
    title: "Aucune transcription",
    transcribe: "Transcrire maintenant",
  },
  streaming: {
    preparing: "Préparation de la lecture en continu",
    notPrepared: "Lecture en continu non préparée",
    preparingBody:
      "Cela prend quelques minutes pour un long enregistrement. Vous pouvez regarder dès maintenant — la lecture deviendra instantanée une fois l’opération terminée.",
    notPreparedBody:
      "La lecture se fait depuis le fichier original, qui doit donc être téléchargé avant de démarrer. L’encoder pour la lecture en continu rend la lecture et le positionnement immédiats.",
    encoding: "Encodage",
    prepare: "Préparer la lecture en continu",
  },
  tabs: {
    transcript: "Transcription",
    chapters: "Chapitres",
    ask: "Demander",
  },
  layout: {
    mergeTitle: "Regrouper les lignes de chaque intervenant en paragraphes",
    splitTitle: "Afficher chaque ligne séparément",
    lines: "Lignes",
    paragraphs: "Paragraphes",
  },
  chapters: {
    regenerating: "Régénération",
    regenerate: "Régénérer",
    dividing: "Découpage de la réunion en chapitres.",
    failed: "Les chapitres n’ont pas pu être générés.",
    empty:
      "Aucun chapitre pour l’instant. Les générer découpe la réunion en sections entre lesquelles vous pouvez naviguer, à l’aide du modèle de votre espace de travail.",
    loadingTranscript: "Chargement de la transcription",
    generate: "Générer les chapitres",
    count_one: "{{count}} chapitre",
    count_other: "{{count}} chapitres",
    trackLabel: "Chapitres",
  },
  player: {
    transcriptTrack: "Transcription",
    jumpToCurrent: "Revenir au passage en cours",
  },
  transcript: {
    empty: "Pas encore de transcription. Elle apparaîtra une fois le traitement terminé.",
    renameSpeaker: "Renommer cet intervenant dans toute la transcription",
    changeSpeakerLabel: "Changer l’auteur de « {{text}} »",
    changeSpeakerTitle: "Attribuer cette ligne à un autre intervenant",
    menuLabel: "Attribuer cette ligne à un intervenant",
    menuHeading: "Attribuer cette ligne à",
    current: "actuel",
    someoneElse: "Quelqu’un d’autre…",
    newSpeakerLabel: "Nommer un nouvel intervenant",
  },
  versions: {
    button: "Versions",
    close: "Fermer les versions",
    loading: "Chargement de l’historique",
    empty: "Aucune version pour l’instant. Chaque génération ou publication en enregistre une ici.",
    current: "actuelle",
    restore: "Restaurer",
  },
  translate: {
    dialogLabel: "Traduire la transcription",
    title: "Traduire en {{language}} ?",
    bodyFrom:
      "Le modèle d’IA de votre espace de travail va traduire la transcription de {{source}} vers {{target}}. La traduction n’est effectuée qu’une fois, est conservée avec l’enregistrement et peut être annulée pendant son exécution.",
    bodyOriginal:
      "Le modèle d’IA de votre espace de travail va traduire la transcription de sa langue d’origine vers {{target}}. La traduction n’est effectuée qu’une fois, est conservée avec l’enregistrement et peut être annulée pendant son exécution.",
    confirm: "Traduire",
  },
  status: {
    stalled: "L’import du fichier ne s’est jamais terminé. Supprimez-le et réessayez.",
    transcribing: "Transcription en cours — cette page se met à jour une fois terminée.",
  },
};

export default recording;
